import React from 'react';

interface HighlightPart {
  text: string;
  highlighted: boolean;
}

interface SafeHighlightProps {
  parts: HighlightPart[];
  className?: string;
}

/**
 * Safe component to render highlighted text without XSS vulnerabilities
 * Replaces dangerouslySetInnerHTML usage with secure DOM elements
 */
export const SafeHighlight: React.FC<SafeHighlightProps> = ({ parts, className }) => {
  return (
    <span className={className}>
      {parts.map((part, index) => 
        part.highlighted ? (
          <mark 
            key={index} 
            className="bg-luxury-red/20 text-luxury-red"
          >
            {part.text}
          </mark>
        ) : (
          <span key={index}>{part.text}</span>
        )
      )}
    </span>
  );
};